import { render } from "./HelpText.vue?vue&type=template&id=77f59be1"
import script from "./HelpText.vue?vue&type=script&lang=js"
export * from "./HelpText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__